import { DeviceStatusType, Feature } from '@vi-iot/client';

export interface ZigbeeTopologyDeviceData {
  parentId: string;
  displayName: string;
  id: string;
  name: string;
  roomName?: string;
  lqiTotal?: number;
  rx?: number;
  tx?: number;
  devices?: ZigbeeTopologyDeviceData[];
  deviceDescription?: string;
  status?: DeviceStatusType;
}

export interface RemoteDevice<T = {}, K = {}> {
  feature: { [featureName: string]: Feature<T, K> };
  values: { [featureName: string]: { [propertyName: string]: any } };
  performing: boolean;
  performed: boolean;
  loading: boolean;
  loaded: boolean;
  error: any;
  featuresWithPendingUpdates: string[];
}

export const queryParamShowDevices = 'showDevices';
